export const TARGETS_LIMIT = 3;
export const VISION_LENGTH = 175;
